"use client";

import { DashboardOverviewSection } from "@/components/app-shell/DashboardOverviewSection";

export function DashboardPage() {
  return <DashboardOverviewSection />;
}
